(function () {
  var SECTION_SELECTOR = '.oddit-header';

  function isHoverPointer(e) {
    return e.pointerType === 'mouse' || e.pointerType === 'pen';
  }

  function initSection(section) {
    var megaMenu = section.querySelector('[data-mega-menu-panel]');
    // Backdrop is a ::after on <main> so it starts below the header and never
    // covers the announcement bar or the header itself.
    var overlay = document.querySelector('.main-content');
    var megaPanels = megaMenu ? megaMenu.querySelectorAll('[data-mega-menu-label]') : [];

    // A section cannot read its theme blocks' settings, so Liquid has no way to know
    // which nav items have a mega menu. Derive it from the panels that rendered.
    (function upgradeNavTriggers() {
      var panelByLabel = Object.create(null);
      for (var p = 0; p < megaPanels.length; p++) {
        panelByLabel[megaPanels[p].getAttribute('data-mega-menu-label')] = megaPanels[p];
      }

      // Thumbnails come from two places: a mega menu's own mobile_image, and the
      // standalone 'oddit-nav-thumb' block for links that have no mega menu.
      // Collected into one map so both are applied by the same code below.
      var thumbByLabel = Object.create(null);
      for (var t = 0; t < megaPanels.length; t++) {
        var panelThumb = megaPanels[t].querySelector('[data-mega-menu-mobile-thumb] img');
        if (panelThumb) thumbByLabel[megaPanels[t].getAttribute('data-mega-menu-label')] = panelThumb;
      }
      var standalone = section.querySelectorAll('[data-nav-thumb-label]');
      for (var n = 0; n < standalone.length; n++) {
        var standaloneImg = standalone[n].querySelector('img');
        if (standaloneImg) thumbByLabel[standalone[n].getAttribute('data-nav-thumb-label')] = standaloneImg;
      }

      var candidates = section.querySelectorAll('[data-nav-label]');
      for (var c = 0; c < candidates.length; c++) {
        var el = candidates[c];
        var label = el.getAttribute('data-nav-label');
        var panel = panelByLabel[label];
        var isMobileLink = el.classList.contains('oddit-header__mobile-nav-link');

        if (panel) {
          el.setAttribute('data-mega-menu-trigger', '');
          el.setAttribute('data-mega-menu-label', label);
          el.setAttribute('aria-expanded', 'false');
          el.setAttribute('aria-haspopup', 'true');
          if (megaMenu && megaMenu.id) el.setAttribute('aria-controls', megaMenu.id);
          if (!isMobileLink) el.classList.add('oddit-header__nav-link--has-dropdown');
        }

        // Runs whether or not a panel matched, so a plain link can carry a
        // thumbnail too.
        var thumb = thumbByLabel[label];
        if (isMobileLink && thumb) {
          var existing = el.querySelector('img');
          if (!existing) {
            el.classList.add('oddit-header__mobile-nav-link--with-image');
            el.insertBefore(thumb.cloneNode(true), el.firstChild);
          } else if (existing.classList.contains('oddit-header__mobile-nav-thumb--fallback')) {
            el.replaceChild(thumb.cloneNode(true), existing);
          }
        }
      }
    })();

    var megaTriggers = section.querySelectorAll('[data-mega-menu-trigger]');
    var menuToggle = section.querySelector('.oddit-header__menu-toggle');
    var mobileMenu = section.querySelector('[data-mobile-menu]');
    var searchToggles = section.querySelectorAll('[data-search-toggle]');
    var cartToggles = section.querySelectorAll('[data-cart-toggle]');

    var nav = section.querySelector('.oddit-header__nav');
    var backLabel = section.querySelector('[data-mega-menu-back-label]');
    var megaBack = section.querySelector('[data-mega-menu-back]');
    var megaClose = section.querySelector('[data-mega-menu-close]');
    var megaCloseTimer = null;
    var activeTrigger = null;
    var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function isMobileTrigger(trigger) {
      return trigger.classList.contains('oddit-header__mobile-nav-link');
    }

    function visibleFocusables(container) {
      if (!container) return [];
      return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE_SELECTOR), function (el) {
        return el.getClientRects().length > 0 && window.getComputedStyle(el).visibility !== 'hidden';
      });
    }

    function nextNavFocusable(trigger) {
      var items = visibleFocusables(nav);
      var index = items.indexOf(trigger);
      return index > -1 ? items[index + 1] || null : null;
    }

    function openMegaMenu(label) {
      if (!megaMenu) return false;
      syncHeaderOffset();
      var shown = false;
      for (var i = 0; i < megaPanels.length; i++) {
        var panel = megaPanels[i];
        if (panel.hasAttribute('data-mega-menu-trigger')) continue;
        var show = panel.getAttribute('data-mega-menu-label') === label;
        panel.style.display = show ? '' : 'none';
        if (show) shown = true;
      }
      // No panel for this nav item — leave it a plain link.
      if (!shown) {
        closeMegaMenu();
        return false;
      }
      megaMenu.classList.add('is-open');
      megaMenu.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-mega-open');
      return true;
    }

    function closeMegaMenu() {
      if (!megaMenu) return;
      megaMenu.classList.remove('is-open');
      megaMenu.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-mega-open');
      for (var i = 0; i < megaTriggers.length; i++) {
        megaTriggers[i].setAttribute('aria-expanded', 'false');
      }
      activeTrigger = null;
    }

    function openMegaMenuFor(trigger) {
      clearTimeout(megaCloseTimer);
      var label = trigger.getAttribute('data-mega-menu-label');
      for (var j = 0; j < megaTriggers.length; j++) {
        megaTriggers[j].setAttribute('aria-expanded', 'false');
      }
      if (!openMegaMenu(label)) return false;
      trigger.setAttribute('aria-expanded', 'true');
      activeTrigger = trigger;
      if (backLabel) backLabel.textContent = trigger.textContent.trim();
      return true;
    }

    // The mobile drawer and mega menu both hang off the bottom of the header, which
    // moves with the announcement bar — measure it instead of assuming a fixed height.
    function syncHeaderOffset() {
      // Set on :root so other sections (e.g. the search drawer) can read it too.
      document.documentElement.style.setProperty('--oddit-header-offset', Math.round(section.getBoundingClientRect().bottom) + 'px');
      // Layout-based twin of the above: announcement bar + header summed from their
      // own box heights, so it stays put when the sticky header detaches on scroll.
      // Sections that size themselves against the viewport (the hero) need that.
      var bar = document.querySelector('.oddit-announcement-bar');
      var stack = (bar ? bar.offsetHeight : 0) + section.offsetHeight;
      document.documentElement.style.setProperty('--oddit-header-stack', Math.round(stack) + 'px');
    }

    function closeMobileMenu() {
      if (!mobileMenu) return;
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      if (menuToggle) {
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.setAttribute('aria-label', 'Open menu');
      }
      document.body.classList.remove('oddit-header-menu-open');
    }

    // The menu sits flush against the nav's bottom edge, so there is no gap to
    // forgive — this only has to outlive the pointerenter that cancels it when the
    // pointer crosses from the nav into the menu (or back).
    function scheduleCloseMegaMenu() {
      clearTimeout(megaCloseTimer);
      megaCloseTimer = setTimeout(function () { closeMegaMenu(); }, 60);
    }

    for (var t = 0; t < megaTriggers.length; t++) {
      (function (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          var isCurrentlyOpen = trigger.getAttribute('aria-expanded') === 'true';
          if (isCurrentlyOpen) {
            closeMegaMenu();
          } else if (openMegaMenuFor(trigger) && e.detail === 0 && isMobileTrigger(trigger)) {
            var panelItems = visibleFocusables(megaMenu);
            if (panelItems.length) panelItems[0].focus();
          }
        });

      })(megaTriggers[t]);
    }

    section.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !activeTrigger || isMobileTrigger(activeTrigger)) return;
      if (!megaMenu || !megaMenu.classList.contains('is-open')) return;
      var items = visibleFocusables(megaMenu);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];

      if (e.target === activeTrigger && !e.shiftKey) {
        e.preventDefault();
        first.focus();
      } else if (e.target === first && e.shiftKey) {
        e.preventDefault();
        activeTrigger.focus();
      } else if (e.target === last && !e.shiftKey) {
        var next = nextNavFocusable(activeTrigger);
        if (next) {
          e.preventDefault();
          closeMegaMenu();
          next.focus();
        }
      }
    });

    document.addEventListener('focusin', function (e) {
      if (!activeTrigger || !megaMenu) return;
      if (e.target === activeTrigger || megaMenu.contains(e.target)) return;
      if (mobileMenu && isMobileTrigger(activeTrigger) && mobileMenu.contains(e.target)) return;
      closeMegaMenu();
    });

    // Hover is delegated over the whole nav so that moving onto a link with no mega
    // menu closes the open one, instead of leaving it up until the pointer exits the bar.
    if (nav) {
      var lastPointerPos = null;
      nav.addEventListener('pointerover', function (e) {
        if (!isHoverPointer(e)) return;
        // Closing the menu changes what sits under a stationary cursor, and Chrome
        // re-fires pointerover for it — which would instantly reopen what just closed.
        var pos = e.clientX + ':' + e.clientY;
        if (pos === lastPointerPos) return;
        lastPointerPos = pos;
        var wrapper = e.target.closest && e.target.closest('.oddit-header__link-wrapper');
        if (!wrapper) return;
        var trigger = wrapper.querySelector('[data-mega-menu-trigger]');
        if (trigger) {
          // pointerover repeats across descendants; only act on an actual change.
          if (trigger !== activeTrigger) openMegaMenuFor(trigger);
          else clearTimeout(megaCloseTimer);
        } else if (activeTrigger) {
          closeMegaMenu();
        }
      });
    }

    // Close is scheduled by leaving the whole nav bar, not an individual link,
    // so sliding between links never starts a close timer.
    if (nav) {
      nav.addEventListener('pointerenter', function (e) {
        if (!isHoverPointer(e)) return;
        clearTimeout(megaCloseTimer);
      });
      nav.addEventListener('pointerleave', function (e) {
        if (!isHoverPointer(e)) return;
        scheduleCloseMegaMenu();
      });
    }

    if (megaMenu) {
      megaMenu.addEventListener('pointerenter', function (e) {
        if (!isHoverPointer(e)) return;
        clearTimeout(megaCloseTimer);
      });
      megaMenu.addEventListener('pointerleave', function (e) {
        if (!isHoverPointer(e)) return;
        scheduleCloseMegaMenu();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function () {
        if (overlay.classList.contains('is-mega-open')) closeMegaMenu();
      });
    }

    if (megaBack) {
      megaBack.addEventListener('click', function () {
        var trigger = activeTrigger;
        closeMegaMenu();
        if (trigger) trigger.focus();
      });
    }

    if (megaClose) {
      megaClose.addEventListener('click', function () {
        closeMegaMenu();
        closeMobileMenu();
      });
    }

    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function () {
        // While search is open the hamburger is showing an X and closes search.
        if (section.classList.contains('is-search-open')) {
          if (window.OdditSearchDrawer) window.OdditSearchDrawer.close();
          return;
        }
        var isOpen = mobileMenu.classList.contains('is-open');
        closeMegaMenu();
        if (isOpen) {
          closeMobileMenu();
        } else {
          syncHeaderOffset();
          mobileMenu.classList.add('is-open');
          mobileMenu.setAttribute('aria-hidden', 'false');
          menuToggle.setAttribute('aria-expanded', 'true');
          menuToggle.setAttribute('aria-label', 'Close menu');
          document.body.classList.add('oddit-header-menu-open');
        }
      });
    }

    window.addEventListener('resize', syncHeaderOffset);
    // The bar and header also reflow without a window resize — webfonts landing,
    // announcement text wrapping, the search row expanding. Watch the boxes, not
    // just the viewport.
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(syncHeaderOffset);
      ro.observe(section);
      var announcementBar = document.querySelector('.oddit-announcement-bar');
      if (announcementBar) ro.observe(announcementBar);
    }
    syncHeaderOffset();
    window.OdditHeader = {
      syncOffset: syncHeaderOffset,
      // The search drawer replaces the menus rather than stacking on top of them.
      closeMenus: function () {
        closeMobileMenu();
        closeMegaMenu();
      }
    };

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var returnFocusTo = activeTrigger && megaMenu && megaMenu.contains(document.activeElement) ? activeTrigger : null;
        closeMegaMenu();
        if (returnFocusTo) returnFocusTo.focus();
        if (mobileMenu && mobileMenu.classList.contains('is-open')) {
          mobileMenu.classList.remove('is-open');
          mobileMenu.setAttribute('aria-hidden', 'true');
          if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('oddit-header-menu-open');
        }
      }
    });

    for (var s = 0; s < searchToggles.length; s++) {
      searchToggles[s].addEventListener('click', function () {
        if (window.OdditSearchDrawer) {
          window.OdditSearchDrawer.open();
        }
      });
    }

    var SMART_CART_WAIT = 4000;
    var pendingCartOpen = null;

    function smartCartReady() {
      return !!(window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function');
    }

    function openCartFallback() {
      if (window.OdditCartDrawer) {
        window.OdditCartDrawer.open();
        return;
      }
      var cartUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
      if (window.location.pathname.replace(/\/$/, '') !== cartUrl.replace(/\/$/, '')) {
        window.location.href = cartUrl;
      }
    }

    function openCart() {
      if (smartCartReady()) {
        window.Rebuy.SmartCart.show();
        return;
      }
      if (pendingCartOpen) return;

      var started = Date.now();
      function finish() {
        document.removeEventListener('rebuy:smartcart.ready', finish);
        clearInterval(pendingCartOpen);
        pendingCartOpen = null;
        if (smartCartReady()) {
          window.Rebuy.SmartCart.show();
        } else {
          openCartFallback();
        }
      }
      document.addEventListener('rebuy:smartcart.ready', finish);
      pendingCartOpen = setInterval(function () {
        if (smartCartReady() || Date.now() - started >= SMART_CART_WAIT) finish();
      }, 100);
    }

    for (var c = 0; c < cartToggles.length; c++) {
      cartToggles[c].addEventListener('click', openCart);
    }

    var desktopSearchInput = section.querySelector('.oddit-header__search-input');
    if (desktopSearchInput) {
      desktopSearchInput.addEventListener('focus', function () {
        if (window.OdditSearchDrawer) window.OdditSearchDrawer.open();
      });
    }

    document.addEventListener('cart:updated', function (e) {
      var cart = e.detail && e.detail.cart;
      if (!cart) return;
      var badges = document.querySelectorAll('[data-cart-count]');
      for (var i = 0; i < badges.length; i++) {
        badges[i].textContent = cart.item_count;
        badges[i].style.display = cart.item_count > 0 ? '' : 'none';
      }
    });
  }

  function closeCurrencySelectors(except) {
    var open = document.querySelectorAll('[data-oddit-currency-selector][open]');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) open[i].removeAttribute('open');
    }
  }

  document.addEventListener('click', function (e) {
    closeCurrencySelectors(e.target.closest ? e.target.closest('[data-oddit-currency-selector]') : null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCurrencySelectors(null);
  });

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector(SECTION_SELECTOR);
    if (s) initSection(s);
  });
})();